import {
  RegExpMatcher,
  englishDataset,
  englishRecommendedTransformers,
} from 'obscenity';

const matcher = new RegExpMatcher({
  ...englishDataset.build(),
  ...englishRecommendedTransformers,
});

/**
 * Check whether text contains profanity.
 * Uses the 'obscenity' package with English dataset and recommended transformers
 * for accurate detection with minimal false positives.
 */
export function containsProfanity(text) {
  if (!text || typeof text !== 'string') return false;
  return matcher.hasMatch(text);
}
